

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(0, _squid.$registerDirective)('xo-address-box', function () {
    return {
        template: _template2['default'],
        scope: {
            header: '=?',
            fullname: '=?',
            addresses: '=?',
            changeFn: '=?'
        },
        lifecycle: {
            enter: function enter() {
                _logger.$logger.info('xo-address-box_enter');
            }
        },
        controller: ['$scope', function ($scope) {
            var addressList = $scope.addresses && $scope.addresses.addresses || [];

            $scope.address = addressList[0] || {};
            $scope.line3 = $scope.address.city + ', ' + $scope.address.state + ' ' + $scope.address.postal_code;
            $scope.updateType = addressList.length > 1 ? _squid.$locale.content.get('common.change') : _squid.$locale.content.get('common.edit');
            $scope.updateFn = function () {
                return $scope.changeFn($scope.updateType);
            };
            $scope.fullname = $scope.fullname;
            if ($scope.fullname) {
                $scope.name = $scope.fullname.first_name + ' ' + $scope.fullname.last_name;
            }
        }]
    };
});

_squid.$registerDirective;

_squid.$locale;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-ui-components/src/address-box/directive.js
// module id = ../node_modules/xo-ui-components/src/address-box/directive.js
// module chunks = 0